import { render, staticRenderFns } from "./publication-manage.vue?vue&type=template&id=13d7e0c2&scoped=true"
import script from "./publication-manage.vue?vue&type=script&lang=js"
export * from "./publication-manage.vue?vue&type=script&lang=js"
import style0 from "./publication-manage.vue?vue&type=style&index=0&id=13d7e0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7e0c2",
  null
  
)

export default component.exports